import { render, staticRenderFns } from "./AgentsOfertaPage.vue?vue&type=template&id=0baabec0&scoped=true&"
import script from "./AgentsOfertaPage.vue?vue&type=script&lang=js&"
export * from "./AgentsOfertaPage.vue?vue&type=script&lang=js&"
import style0 from "./AgentsOfertaPage.vue?vue&type=style&index=0&id=0baabec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baabec0",
  null
  
)

export default component.exports